import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "@/contexts/theme";

/**
 * Tri-state toggle: System → Light → Dark → System
 * Compact icon-only variant for sidebars and headers.
 */
export default function ThemeToggle({ className = "", testId = "theme-toggle" }) {
  const { mode, resolved, setMode } = useTheme();

  const next = mode === "system" ? "light" : mode === "light" ? "dark" : "system";
  const label =
    mode === "system" ? "Tema do sistema" : mode === "dark" ? "Modo escuro" : "Modo claro";

  const Icon = mode === "system" ? Monitor : resolved === "dark" ? Moon : Sun;

  return (
    <button
      type="button"
      onClick={() => setMode(next)}
      data-testid={testId}
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center w-9 h-9 rounded-md border border-border bg-card text-muted-foreground hover:text-foreground hover:bg-muted transition-colors ${className}`}
    >
      <Icon className="w-4 h-4" strokeWidth={1.6} />
    </button>
  );
}
